// export const signKey = 'TUQ8C6mSFV47hUJDBqd6enUsiG7kJheSLa3RWxH3Msc='
// export const appId = 'ninja3_ali'
export const test = true;
// export const signKey = 'Bapt6WLHVsYHcGE8Hkb67huFBkAiWQwA6ypt7JTfBLg='
export const appId = 'ninja3_twitchdrop';
export const signKey = test ? 'CpabKcp6Nkst97tEGN9tA5uUfmia486rfJVhE4Ys968' : 'Bapt6WLHVsYHcGE8Hkb67huFBkAiWQwA6ypt7JTfBLg=';
export default {
	tc: {
		shareTitle: '觀看實況 贏取獎勵',
		shareDesc: '【忍者必須死-全球版】快來觀看實況，綁定Twitch掉寶，領取更多獎勵吧！',
		// shareUrl: test ? 'https://www.pandadagames.com/twitch-drop/7F3N5B1D8A9C2E/index.html' : "https://www.pandadagames.com/twitchdrops/index.html",
		shareUrl: 'https://www.pandadagames.com/twitchdrops/index.html',
		shareImg: "https://www.pandadagames.com/twitchdrops/shareTC.jpg",
		clipText: '【忍者必須死-全球版】快來觀看實況，綁定Twitch掉寶，領取更多獎勵吧！',
		r3Account: 'step1 忍者必須死-全球版帳號',
		twitchAccount: 'step2 Twitch帳號',
		readRule: '查看規則',
		login: '點擊登入',
		logout: '登出',
		copy: '複製',
		copySuccess: '複製成功',
		bindSuccess: '綁定成功',
		bindSuccess2: '恭喜你，綁定成功',
		networkErr: '網路異常請重試',
		confirm: '確認',
        bind:"綁定並啟動Twitch Drops",

		enterTwitch: '進入Twitch頁面',
		bindEnter: '綁定並啟動Twitch Drops',

		
		qaList: [
			{
				q: '什麼是Twitch Drops？',
				a: 'Twitch Drops是僅通過觀看Twitch直播就能獲得遊戲獎勵的活動。為參與Twitch Drops您只需綁定你的Twitch帳號和忍者必須死-全球版帳號。未綁定Twitch帳號的忍忍們，請至少於當期Drops活動結束後一週內綁定，逾期獎勵將無法發放。'
			},
			{
				q: '需要觀看哪些直播才能獲得獎勵？',
				a: '啟動Twitch Drops後，觀看任何NinjaMustDie類別的直播即可參與活動。您可以在前往官網（<a href="https://www.pandadagames.com/tc/">https://www.pandadagames.com/tc/</a>）確認所有關於活動開啟及獎勵相關資訊。'
			},
			{
				q: '如何確認是否成功參與了Twitch Drops活動？',
				a: '您可以在Twitch Drops頁面查看已參與的Twitch Drops活動，還可以在Twitch Inventory中確認正在進行的所有活動和已經參與的頻道。'
			},
			{
				q: '多久能收到Drops獎勵？',
				a: '通常24小時內發放到您的遊戲內郵箱。'
			},
			{
				q: '我有兩個遊戲帳號，可以重複領取獎勵嗎？',
				a: '不能重複領取DROPS獎勵。一個Twitch帳號只能綁定一個忍者必須死-全球版角色UID。同個忍者必須死-全球版帳號同種獎勵只能領取一次，同個Twitch帳號同種獎勵只能領取一次。'
			},
			{
				q: '我必須要持續觀看同一實況來獲得掉寶嗎？',
				a: '忍忍們可以觀看在 Twitch《NinjaMustDie》類別中任何提供掉寶的頻道來獲得獎勵進度。舉例來說，忍忍們前半個小時可以觀看某個頻道，接下來的時間再觀看其他頻道，也不會失去掉寶進度。但同一時間觀看多個實況不會加快你獲得掉寶的速度。'
			},
			{
				q: '我會自動收到遊戲中的 Twitch Drops 獎勵嗎？',
				a: '不可以。忍忍必須在您正在觀看的頻道或 Twitch 上的 Drops Inventory 選單中領取掉落物品。'
			}
		],
		rule: `<p class="t">【參與條件】</p>
		<p>擁有忍者必須死-全球版角色和Twitch帳號的忍忍們即可參與活動。</p>
		<p class="t">【活動介紹】</p>
		<p>忍忍們可以在本頁面綁定Twitch帳號和忍者必須死-全球版帳號，啟動Twitch Drops。綁定帳號後，觀看任何NinjaMustDie類別的直播且滿足觀看時間要求，即可領取Drops獎勵。</p>
		<p class="t">【常見問題】</p>
		<p>
		Twitch Drops是僅通過觀看Twitch直播就能獲得遊戲獎勵的活動。為參與Twitch Drops，忍忍只需對Twitch帳號和忍者必須死帳號進行綁定。未綁定Twitch帳號的忍忍們，請至少於當期Drops活動結束後一週內綁定，逾期獎勵將無法發放。
		</p>
		<p>啟動Twitch Drops後，觀看任何NinjaMustDie類別的直播即可參與活動。</p>
		<p>忍忍們可以在Twitch Drops頁面查看已參與的Twitch Drops活動，還可以在Twitch Inventory中確認正在進行的所有活動和已經參與的頻道。</p>
		<p>獎勵通常24小時內發放到對應綁定的忍者必須死-全球版帳號的遊戲內郵箱。郵件有效期為30天，請及時領取。</p>
		<p>*領取獎勵後如需解綁，請忍忍們耐心等待獎勵發放到對應角色郵箱後再進行解綁操作。</p>`,
		apiErrMsg: {
			10001: '賬號已被綁定，請確認',
			10008: '賬號已被綁定，請確認',
			10009: '帳號不存在或已被綁定，請確認',
			10004: '網路異常請重試',
			10005: '網路異常請重試',
			10006: '網路異常請重試',
			10007: '網路異常請重試',
			10002: '出現錯誤請重試',
			10010: '出現錯誤請重試',
			10011: '出現錯誤請重試',
		},
		title: '【忍者必須死-全球版】綁定Twitch掉寶，領取更多獎勵',
	},
	en: {
        shareTitle: 'Watch steams to win rewards!',
		shareDesc: '[Ninja Must Die] Watch live streams, connect your Twitch Drops account, and receive more rewards!',
		// shareUrl: test ? 'https://www.pandadagames.com/twitch-drop/7F3N5B1D8A9C2E/en.html' : "https://www.pandadagames.com/twitchdrops/en.html",
		shareUrl: "https://www.pandadagames.com/twitchdrops/en.html",
        shareImg: "https://www.pandadagames.com/twitchdrops/shareEN.jpg",
        clipText: '[Ninja Must Die] Watch live streams, connect your Twitch Drops account, and receive more rewards!',
		r3Account: 'step1 Ninja Must Die Account',
		twitchAccount: 'step2 Twitch Account',
		readRule: 'Event Description',
		login: 'Log in',
		logout: 'Log out',
		copy: 'Copy',
		copySuccess: 'Copied successfully',
		bindSuccess: 'Bound successfully',
		bindSuccess2: 'Congratulations, the bind is successful.',
		networkErr: 'Network error. Please try again.',
		confirm: 'Confirm',
        bind:"Bind and activate Twitch Drops",

		enterTwitch: 'Enter the Twitch page',
		bindEnter: 'Bind and activate Twitch Drops',

		qaList: [
			{
				q: 'What is Twitch Drops?',
				a: 'Twitch Drops is an event where you can obtain in-game rewards just by watching Twitch live streams. To participate in Twitch Drops, you only need to link your Twitch account to your Ninja Must Die account.If you have not yet linked your Twitch account and your Ninja Must Die account, please do so within one week after the end of the current Twitch Drops event. If the deadline is exceeded, it will no longer be possible to claim the rewards.'
			},
			{
				q: 'Which live streams do I need to watch in order to obtain the rewards?',
				a: `After activating Twitch Drops, watch any stream under the NinjaMustDie category to participate in the event.You can confirm all information about the event and rewards at our Official Website(<a href="https://www.pandadagames.com/en/">https://www.pandadagames.com/en/</a>)`
			},
			{
				q: 'How do I confirm that I have successfully participated in Twitch Drops?',
				a: 'You can view the Twitch Drops events you have participated in on the Twitch Drops page. You can also confirm all ongoing events and the channels you have joined in the Twitch Inventory.'
			},
			{
				q: 'How long will it take to receive the Drops reward?',
				a: 'In general, rewards will be delivered to your in-game mailbox within 24 hours.'
			},
			{
				q: 'I have two game accounts, can I receive the rewards more than once?',
				a: 'You are unable to receive Twitch Drops rewards repeatedly. A Twitch account can only be linked to one Ninja Must Die account (UID). The same Ninja Must Die account can only collect the same types of rewards once, and the same Twitch account can only claim the same types of rewards once.'
			},
			{
				q: 'Do I have to keep watching the same Twitch live to get Drops?',
				a: "You can have rewards progress by watching any channel in Twitch's NinjaMustDie category that offers drops. For example, you can watch a channel for the first half hour and then watch other channels for the rest of the time without losing progress. However, watching multiple Twitch lives at the same time will not speed up the rate of getting drops."
			},
			{
				q: 'Will I automatically receive in-game Twitch Drops rewards?',
				a: 'No. You must claim the rewards in the Drops Inventory interface on the channel you are watching or on Twitch.'
			}
		],
		rule: `<p class="t">【Eligibility】</p>

        <p>Any ninjas with a Twitch account and a Ninja Must Die account can participate in the event.</p>
        
        <p class="t">【Event Description】</p>
        
        <p>Ninjas can link the Twitch account to the Ninja Must Die account to activate Twitch Drops on this page. After linking the accounts, you can receive Drops rewards if you watch any live stream in the NinjaMustDie category and meet the viewing time requirements.</p>
        
        <p class="t">【FAQ】</p>
        
        <p>Twitch Drops is an event where you can obtain in-game rewards just by watching Twitch live streams. To participate in Twitch Drops, ninjas only need to link Twitch account to Ninja Must Die account. If you have not yet linked your Twitch account and your Ninja Must Die account, please do so within one week after the end of the current Twitch Drops event. If the deadline is exceeded, it will no longer be possible to claim the rewards.</p>
        
        <p>After activating Twitch Drops, watch any stream under the NinjaMustDie category to participate in the event.</p>
        
        <p>Ninjas can view the Twitch Drops events you have participated in on the Twitch Drops page. You can also confirm all ongoing events and the channels you have joined in the Twitch Inventory.</p>
        
        <p>The in-game rewards will be distributed via in-game mail within 24 hours. The mail will expire after 30 days, so don't forget to claim the rewards in time.</p>
        
        <p>*If you need to unlink your accounts after collecting the rewards, please wait for the rewards to be delivered via the corresponding account's in-game mail before proceeding.</p>`,
		apiErrMsg: {
			10001: 'The account has been bound, please confirm',
			10008: 'The account has been bound, please confirm',
			10009: 'The account does not exist or has been bound, please confirm',
			10004: 'Network error. Please try again.',
			10005: 'Network error. Please try again.',
			10006: 'Network error. Please try again.',
			10007: 'Network error. Please try again.',
			10002: 'An error occurred. Please try again.',
			10010: 'An error occurred. Please try again.',
			10011: 'An error occurred. Please try again.',
		},
		title: '[Ninja Must Die] Link to your Twitch Drops account to receive more rewards'
	},
	ja: {
        shareTitle: '「忍者マストダイ」配信を視聴して、賞品をゲット！',
		shareDesc: '【忍者マストダイ】の配信を見て、Twitch Dropsを紐付けし、さらなる報酬を獲得しよう！',
		// shareUrl: test ? 'https://www.pandadagames.com/twitch-drop/7F3N5B1D8A9C2E/ja.html' : "https://www.pandadagames.com/twitchdrops/ja.html",
		shareUrl: "https://www.pandadagames.com/twitchdrops/ja.html",
		shareImg: "https://www.pandadagames.com/twitchdrops/shareJA.jpg",
		clipText: '【忍者マストダイ】の配信を見て、Twitch Dropsを紐付けし、さらなる報酬を獲得しよう！',
		r3Account: 'step1 『忍者マストダイ』アカウント',
		twitchAccount: 'step2 Twitchアカウント',
		readRule: 'イベントルール',
		login: 'ログイン',
		logout: 'ログアウト',
		copy: 'コピー',
		copySuccess: 'コピーが成功しました',
		bindSuccess: '成功',
		bindSuccess2: 'おめでとうございます！アカウントを紐付けました',
		networkErr: 'ネットワークエラー。もう一度試してみてください',
		confirm: '確認',
        bind:"Twitch Dropをアクティブ化にする",

		enterTwitch: 'Twitchページに入る',
		bindEnter: 'Twitch Dropをアクティブ化にする',

		qaList: [
			{
				q: 'Twitch Dropsとは？',
				a: 'Twitch DropsはTwitchのライブを見るだけでゲーム報酬を獲得できるイベントです。Twitchアカウントと『忍者マストダイ』アカウントを紐付けていただければ、Twitch Dropsに参加できます！Twitchアカウントを紐付けしていない旅人さんは、今期のDropsイベント終了後、一週間以内に紐付けを完了させてください。この期限を過ぎると、報酬の配布ができなくなります。'
			},
			{
				q: '報酬を獲得するには、どのライブを見ればいいですか？',
				a: `Twitch Dropsをアクティブ化した後、NinjaMustDieに関するあらゆるジャンルのライブを見ていただくことでイベントに参加できます。公式サイト（<a href="https://www.pandadagames.com/ja/">https://www.pandadagames.com/ja/</a>）よりイベントの開催と報酬に関する情報を確認できます。`
			},
			{
				q: 'Twitch Dropsに参加したかどうかはどうやって確認できますか？',
				a: 'Twitch Dropsページより参加したTwitch Dropsイベントを確認できます。また、Twitch Inventoryで進行中のイベントや参加済みのチャンネルも確認できます。'
			},
			{
				q: 'Drops報酬はどのくらいで受け取れますか？',
				a: '通常24時間以内にゲーム内メールボックスで配布いたします。'
			},
			{
				q: '二つのゲームアカウントを持っている場合、それぞれのアカウントで報酬を貰えますか？',
				a: 'Drops報酬を重複して受け取ることはできません。一つのTwitchアカウントに対して、一つの『忍者マストダイ』アカウント（UID）しか紐付けられません。また、一つの『忍者マストダイ』/Twitchアカウントにつき、同じタイプの報酬は一回しか受け取ることができません。'
			},
			{
				q: '報酬を獲得するため、同じ実況者のTwitchライブを見続けなければならないですか？',
				a: 'TwitchのNinjaMustDieに関するあらゆるジャンルのライブを見ていただくことでイベントに参加できます。\n\nたとえば、最初の30分はとあるチャンネルを視聴し、その後の30分は他のチャンネルを視聴しても、Twitch Dropsの進行状況を失うことになりません。ただし、複数のライブストリームを同時に視聴しても、Twitch Dropsの進行状況を早くすることもなりません'
			},
			{
				q: '自動的にゲーム内でTwitch Dropsの報酬を受け取ることができますか？',
				a: 'それはできません。視聴しているチャンネルまたはTwitchのDrops Inventoryメニューで報酬を受け取る必要があります。'
			}
		],
		rule: ` <p class="t">【参加条件】</p>
          <p>『忍者マストダイ』アカウントデータとTwitchアカウントを持っている忍者殿の皆さん。</p>
          
          <p class="t">【イベント詳細】</p>
          <p>忍者殿は、本ページよりTwitchアカウントと『忍者マストダイ』アカウントを紐付けして、Twitch Dropsをアクティブ化することができます。紐付け後、『NinjaMustDie』に関する任意のジャンルのライブを指定された時間視聴すると、Drops報酬を獲得できます。</p>
          
          <p class="t">【よくあるお問い合わせ】</p>
          <p>Twitch DropsはTwitchのライブを見るだけでゲーム報酬を獲得できるイベントです。Twitchアカウントと『忍者マストダイ』アカウントを紐付けていただければ、Twitch Dropsに参加できます！</p>
          <p>Twitchアカウントを紐付けしていない忍者殿は、今期のDropsイベント終了後、一週間以内に紐付けを完了させてください。この期限を過ぎると、報酬の配布ができなくなります。</p>
          
          <p>Twitch Dropsをアクティブ化した後、『忍者マストダイ』に関するあらゆるジャンルのライブを見ていただくことでイベントに参加できます。</p>
          <p>Twitch Dropsページより参加したTwitch Dropsイベントを確認できます。また、Twitch Inventoryで進行中のイベントや参加済みのチャンネルも確認できます。</p>
          
          <p>イベント報酬は、24時間以内に紐付けされた『忍者マストダイ』アカウントのゲーム内メールボックスへ配布いたします。メールの有効期限は30日となります。受け取り忘れがないようご注意ください。</p>
          <p>※紐付けを解除したい場合、対応するゲーム内メールに報酬が届いてから行ってください。</p>`,
		apiErrMsg: {
			10001: 'アカウントが既に紐付けました。ご確認ください。',
			10008: 'アカウントが既に紐付けました。ご確認ください。',
			10009: 'アカウントが存在しない／既に紐付けました。ご確認ください。',
			10004: 'ネットワークエラー。もう一度試してみてください',
			10005: 'ネットワークエラー。もう一度試してみてください',
			10006: 'ネットワークエラー。もう一度試してみてください',
			10007: 'ネットワークエラー。もう一度試してみてください',
			10002: 'エラーが発生した。もう一度試してみてください',
			10010: 'エラーが発生した。もう一度試してみてください',
			10011: 'エラーが発生した。もう一度試してみてください',
		},
		title: '【忍者マストダイ】Twitch Dropsと紐付けして報酬を獲得'
	},
	ko: {
        shareTitle: '라이브 시청하고 보상 획득!',
		shareDesc: '[닌자 머스트 다이] 라이브를 시청하고 twitch drops를 연동하여 더 많은 보상을 수령하세요!',
		// shareUrl: test ? 'https://www.pandadagames.com/twitch-drop/7F3N5B1D8A9C2E/ko.html' : "https://www.pandadagames.com/twitchdrops/ko.html",
		shareUrl: "https://www.pandadagames.com/twitchdrops/ko.html",
		shareImg: "https://www.pandadagames.com/twitchdrops/shareKO.jpg",
		clipText: '[닌자 머스트 다이] 라이브를 시청하고 twitch drops를 연동하여 더 많은 보상을 수령하세요!',
		r3Account: 'step1 닌자 머스트 다이 계정',
		twitchAccount: 'step2 Twitch 계정',
		readRule: '이벤트 규칙',
		login: '로그인하기',
		logout: '로그아웃',
		copy: '복사',
		copySuccess: '복사 성공',
		bindSuccess: '계정 연동 성공 ',
		bindSuccess2: '계정 연동에 성공했습니다',
		networkErr: '네트워크 오류, 다시 시도해 주시길 바랍니다.',
		confirm: '확인',
        bind:"Twitch Drops 활성화",

		enterTwitch: 'Twitch 페이지 접속하기',
		bindEnter: 'Twitch Drops 활성화',

		qaList: [
			{
				q: 'Twitch Drops란?',
				a: 'Twitch Drops는 Twitch 라이브를 시청하면 획득할 수 있는 보상 이벤트입니다. Twitch 계정과 닌자 머스트 다이 계정을 연동하면 Twitch Drops에 참여할 수 있습니다. Twitch에 계정을 연동하지 않은 닌자님은 이번 드롭스 이벤트 종료 후 일주일이 지나기 전까지 연동해야 합니다. 기간을 초과할 경우 보상을 수령할 수 없습니다.'
			},
			{
				q: '어떤 라이브를 시청해야 보상을 얻을 수 있나요?',
				a: `Twitch Drops 활성화 이후, NinjaMustDie 관련 라이브를 시청하면 이벤트에 참여할 수 있습니다. 닌자님께선 이곳(<a href="https://www.pandadagames.com/ko/">https://www.pandadagames.com/ko/</a>)에서 이벤트 오픈 및 보상 관련 정보를 확인하실 수 있습니다.`
			},
			{
				q: 'Twitch Drops 이벤트 참여 성공 여부를 어떻게 확인하나요?',
				a: 'Twitch Drops 페이지에서 이미 참여한 Twitch Drops 이벤트를 확인하실 수 있습니다. 또한, Twitch Inventory에서 현재 진행 중인 모든 이벤트 및 이미 참여한 채널을 확인 가능합니다.'
			},
			{
				q: 'Twitch Drops 보상을 수령하는데 걸리는 시간은?',
				a: '일반적으로 24시간 이내에 게임 내 우편으로 지급됩니다.'
			},
			{
				q: '게임 계정이 두 개일 경우, 중복 수령이 가능한가요?',
				a: 'Twitch Drops 보상을 중복 수령할 수 없습니다. Twitch 계정당 1개의 닌자 머스트 다이 계정(UID) 연동이 가능합니다. 동일 닌자 머스트 다이 계정으로 같은 보상을 한 번만 수령할 수 있고, 동일 Twitch 계정으로 같은 보상을 한 번만 수령할 수 있습니다.'
			},
			{
				q: '한 명의 라이브만 지속해서 시청해야 보상을 받을 수 있나요?',
				a: 'Twitch NinjaMustDie 카테고리에서 Twitch Drops 을 제공하는 채널에선 모두 해당 보상을 받을 수 있습니다. 예를 들어 30분간 라이브를 시청한 후 나머지 시간 동안 진행률을 잃지 않고 다른 라이브를 시청할 수 있습니다. 그러나 여러 개의 Twitch 라이브를 동시에 시청한다고 해서 보상을 받는 속도가 빨라지지는 않습니다.'
			},
			{
				q: '저는 자동으로 게임 내 Twitch Drops 보상을 받을 수 있나요? ',
				a: '아니요, 지금 보고 계신 라이브나 트위치의 드롭스 및 보상 - 인벤토리 옵션에서 획득한 보상을 받으셔야 합니다.'
			}
		],
		rule: `<p class="t">【참여 조건】</p>
        <p>닌자 머스트 다이 계정 및 Twitch 계정이 있는 모든 닌자님 이벤트에 참여할 수 있습니다.</p>
        
        <p class="t">【이벤트 소개】</p>
        <p>닌자님은 본 페이지에서 Twitch 계정 및 닌자 머스트 다이 계정을 연동하고 Twitch Drops를 활성화할 수 있습니다. 계정 연동 후, NinjaMustDie 관련 라이브를 시청하고 시청 시간 요구사항을 충족하면 즉시 Drops 보상을 수령할 수 있습니다.</p>
        
        <p class="t">【자주 묻는 질문】</p>
        <p>Twitch Drops는 Twitch 라이브를 시청하면 게임 보상을 획득할 수 있는 이벤트입니다. Twitch 계정과 닌자 머스트 다이 계정을 연동하면 Twitch Drops에 참여할 수 있습니다.</p>
        <p>Twitch에 계정을 연동하지 않은 닌자님은 이번 드롭스 이벤트 종료 후 일주일이 지나기 전까지 연동해야 합니다. 기간을 초과할 경우 보상을 수령할 수 없습니다.</p>
        
        <p>Twitch Drops 활성화 이후, NinjaMustDie 관련 라이브를 시청하면 이벤트에 참여할 수 있습니다.</p>
        <p>Twitch Drops 페이지에서 이미 참여한 Twitch Drops 이벤트를 확인하실 수 있습니다. 또한, 드롭스 및 보상 - 인벤토리에서 현재 진행 중인 모든 이벤트 및 이미 참여한 채널을 확인 가능합니다.</p>
        
        <p>이벤트 보상은 일반적으로 24시간 내에 연동한 닌자 머스트 다이 계정의 게임 내 우편을 통해 발송될 예정입니다. 우편의 유효시간은 30일이니 잊지 말고 수령해 주세요.</p>
        <p>* 보상 수령 후 연동 해제가 필요할 경우, 닌자님께서는 상응하는 계정 우편으로 보상이 지급되는 걸 기다렸다가 다시 연동 해제를 진행해 주세요.</p>`,
		apiErrMsg: {
			10001: '계정이 이미 연동되었습니다. 확인 바랍니다.',
			10008: '계정이 이미 연동되었습니다. 확인 바랍니다.',
			10009: '계정이 존재하지 않거나 이미 연동된 상태입니다. 확인 바랍니다.',
			10004: '네트워크 오류, 다시 시도해 주시길 바랍니다.',
			10005: '네트워크 오류, 다시 시도해 주시길 바랍니다.',
			10006: '네트워크 오류, 다시 시도해 주시길 바랍니다.',
			10007: '네트워크 오류, 다시 시도해 주시길 바랍니다.',
			10002: '시스템 오류, 다시 시도해 주시길 바랍니다. ',
			10010: '시스템 오류, 다시 시도해 주시길 바랍니다. ',
			10011: '시스템 오류, 다시 시도해 주시길 바랍니다. ',
		},
		title: '[닌자 머스트 다이] Twitch Drops 연동하고 더 많은 보상 수령',
	}
}
